import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './config/router'
import store from './config/store'

import './config/msgs'
import './assets/styles/global.scss'
// import * as faceapi from 'face-api.js';

Vue.config.productionTip = false

import mask from 'vuejs-mask'
Vue.use(mask)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
